import React from "react";



const UnavailablePage=()=>{
	return(

<div>
<h2> This Page Is Currently Unavailable </h2>
</div>

		)
}
export default UnavailablePage;